import { Component, HostBinding, Input, OnInit, inject } from '@angular/core';
import { ISystemPreferences, SystemPreferencesService, VERSION } from '@lib/core';
import { EnvService } from '@lib/env';
import { MobileService } from '@lib/util';

@Component({
    selector: 'shop-name',
    templateUrl: './shop-name.component.html',
    styleUrls: ['./shop-name.component.scss'],
    standalone: false
})
export class ShopNameComponent implements OnInit {
    readonly systemPreferencesService = inject(SystemPreferencesService);
    readonly mobileService = inject(MobileService);

    public preferences?: ISystemPreferences;
    public version = VERSION;
    public env = EnvService;
    @Input({ required: true }) public isDeeplink!: boolean;

    @HostBinding('class') classes = '';

    ngOnInit(): void {
        this.systemPreferencesService
            .getPreferences()
            .subscribe((preferences: ISystemPreferences) => (this.preferences = preferences));
    }
}
